module.exports = __webpack_public_path__ + "home_modelo1.f90fb1c64cff67a6cf66.png";


//////////////////
// WEBPACK FOOTER
// C:/Front-end/[PROYECTO] abordo-empresarial-cli4/[RAMA] actualizarAngular-Analytics/abordo-empresarial-cli4/src/assets/images/home_modelo1.png
// module id = ../../../../../src/assets/images/home_modelo1.png
// module chunks = 1